export class SagaStatusEventMessageArbetsorderData {
    arbetsorderId: number;
    messageType: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SagaStatusEventMessageArbetsorderData";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static messageType = "Arbetsorder";
}
